/* eslint-disable react/prop-types */
import ReserchFormComponent from "./reserch-form";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as annoucementSlice from "../build-your-solution.slice";
import * as app from "@/app/app.slice";
import regionsFile from "@/static-texts/regions.json";

const REGION_PLACEHOLDER = "Seleziona la regione";
const CITY_PLACEHOLDER = "Seleziona la provincia";
const NONE_FILTER = {
  cities: [],
};
const { regioni } = regionsFile;

function ReserchForm({ onSearchClick }) {
  const dispatch = useDispatch();
  const { cities: initialCities, region: initialRegion } = useSelector(
    annoucementSlice.selectDetailsFilters
  );

  const [regions, setRegions] = useState(
    initializeReggions({ regioni, initialRegion })
  );

  const [cities, setCities] = useState(
    initialCities?.length ? initialCities : []
  );
  const [selectedRegion, setSelectedRegion] = useState({
    name: initialRegion?.name ? initialRegion.name : REGION_PLACEHOLDER,
  });

  const [selectedCities, setSelectedCities] = useState(
    initialCities?.length
      ? updateSelectedCities({ cities: initialCities })
      : CITY_PLACEHOLDER
  );

  const [filters, setFilter] = useState(NONE_FILTER);

  useEffect(() => {
    const region = regions.find(({ isSelected }) => isSelected === true);
    if (region) {
      setSelectedRegion(region);
      setCities(initializeCities({ cities: regionsFile[`${region?.name}`] }));
      setSelectedCities(CITY_PLACEHOLDER);
    } else {
      setSelectedRegion({ name: REGION_PLACEHOLDER });
      setSelectedCities(CITY_PLACEHOLDER);
      setCities([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regions]);

  useEffect(() => {
    const citiesOfInterest = cities.filter(
      ({ isSelected }) => isSelected === true
    );
    if (citiesOfInterest?.length) {
      setSelectedCities(updateSelectedCities({ cities }));
    } else {
      setSelectedCities(CITY_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cities]);

  useEffect(() => {
    const citiesOfInterest = cities.filter(
      ({ isSelected }) => isSelected === true
    );
    if (citiesOfInterest?.length) {
      setFilter(updateFilters({ citiesOfInterest }));
      dispatch(annoucementSlice.setFilterCities({ selectedCities: cities }));
    } else {
      dispatch(annoucementSlice.setFilterCities({ selectedCities: [] }));
      setFilter(NONE_FILTER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCities]);

  const handleRegionSelect = ({ name }) => {
    setRegions(updateRegions({ name, regions }));
    dispatch(annoucementSlice.setFilterRegion({ selectedRegion: { name } }));
  };

  const handleCitySelect = ({ name }) => {
    setCities(updateCities({ name, cities }));
  };

  const handleClick = () => {
    var filtresToUsed = { ...filters };
    if (selectedCities === CITY_PLACEHOLDER) {
      filtresToUsed = updateFilters({
        citiesOfInterest: regionsFile[`${selectedRegion?.name}`],
      });
    }
    dispatch(annoucementSlice.searchAnnouncements(filtresToUsed));
    dispatch(app.fetchServices());
    onSearchClick();
  };

  return (
    <ReserchFormComponent
      selectedRegion={selectedRegion}
      selectedCities={selectedCities}
      regions={regions}
      cities={cities}
      isRegionFilterUsed={
        selectedRegion?.name !== undefined &&
        selectedRegion?.name !== REGION_PLACEHOLDER
      }
      isCitiesFilterUsed={selectedCities !== CITY_PLACEHOLDER}
      onCitySelect={handleCitySelect}
      onRegionSelect={handleRegionSelect}
      onClick={handleClick}
    />
  );
}

function updateCities({ name, cities }) {
  return cities.map((city) => {
    return {
      ...city,
      isSelected: city.name === name ? !city.isSelected : city.isSelected,
    };
  });
}

function updateSelectedCities({ cities }) {
  var value = "";
  cities?.forEach(({ sigla, isSelected }) => {
    if (isSelected) {
      if (value.length) {
        value = value + ",";
      }
      value = value + sigla;
    }
  });
  if (value === "") {
    value = CITY_PLACEHOLDER;
  }
  return value;
}

function updateFilters({ citiesOfInterest }) {
  var cities = [];
  citiesOfInterest.forEach(({ name }) => {
    cities.push(name);
  });
  return { cities };
}

function updateRegions({ name, regions }) {
  return regions.map((regione) => {
    return {
      ...regione,
      isSelected: regione.name === name ? !regione.isSelected : false,
    };
  });
}

function initializeReggions({ regioni, initialRegion }) {
  const sorteredRegions = regioni.sort((item1, item2) => {
    if (item1.name < item2.name) return -1;
    if (item1.name > item2.name) return 1;
    else return 0;
  });
  return sorteredRegions.map((regione) => {
    return {
      ...regione,
      isSelected: regione?.name === initialRegion?.name,
    };
  });
}

function initializeCities({ cities }) {
  return cities.map((city) => {
    return {
      ...city,
      isSelected: false,
    };
  });
}

export default ReserchForm;
